import { Link } from "react-router-dom";
import { CtaBand } from "../components/CtaBand";
import { FaqList } from "../components/FaqList";
import { PageHeader } from "../components/PageHeader";
import "./styles/FaqPage.css";

export function FaqPage() {
  return (
    <>
      <PageHeader eyebrow="FAQ" title="Questions, answered" />
      <div className="container page-body">
        <FaqList />
        <p className="faq-page__more">Still wondering about something? <Link to="/contact">Ask us</Link>.</p>
      </div>
      <CtaBand />
    </>
  );
}
